import styled from "styled-components";
import * as Variables from "./../globalStyles/Variables";
import { AddButton } from "../globalStyles/CommonStyles";
import { productType } from "../utils/types";
import { useRecoilState } from "recoil";
import { useHistory } from "react-router-dom";
import { cartState } from "../recoil/Atoms";
import { useAddProduct, useRemoveProduct } from "../recoil/hooks";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";
import { ReactComponent as LessIcon } from "../assets/icons/less.svg";
import { ReactComponent as RemoveIcon } from "../assets/icons/remove.svg";
import { motion } from "framer-motion";
import { analytics } from "../firebase.config";
import { logEvent } from "@firebase/analytics";

const ProductContainer = styled.li`
  border-radius: 6px;
  overflow: hidden;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px 16px ;
  padding: 10px;
`;

const ProductPicture = styled.img`
  background: ${Variables.getColor().textColor}10;
  filter: drop-shadow(0px 0px 10px ${Variables.getColor().secondary}20);
  border-radius: 10px;
  width: 80px;
  height: 64px;
  object-fit: cover;

  @media ${Variables.device.tablet}{
    width: 120px;
  height: 80px;
  }
  
`;

const SeparatorProduct = styled.div`
  width: 4px;
  height: 100%;
  background-color: ${Variables.getColor().secondary};
  filter: drop-shadow(0px 0px 10px ${Variables.getColor().secondary}20);
  border-radius: 4px;
`;

const ProductContent = styled.div`
  align-self: center;
  h3 {
    font-size: 1.4rem;
    font-weight: 600;
  }
  p {
    font-size: 1.1rem;
  }
`;

const DiscountedPrice = styled.span`
    text-decoration: line-through;
    opacity: 0.5;
    font-size: 1.2rem;
    margin-right: 6px;
`;

const DiscountBadge = styled.span`
  position: absolute;
    top: 7px;
    left: 0;
    z-index: 1;
    padding: 5px 9px 5px 5px;
    background: #d74339;
    display: flex;
    align-content: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 600;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
    box-shadow: 1;
`;



const PriceActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;

  h4 {
    font-size: 1.6rem;
    font-weight: 600;
    color: ${Variables.getColor().textColor};
    margin-bottom: 5px;

    span {
      font-weight: 400;
    }
  }
  p {
    font-size: 0.7rem;
  }
`;

const CountButton = styled.div`
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  background: ${Variables.getColor().accent};
  box-shadow: 1px 1px 15px ${Variables.getColor().accent}60;
  color: ${Variables.getColor().textColor}60;
  border-radius: 12px;
  min-height: 40px;

  p {
    padding: 0 6px;
    font-size: 1.3rem;
    color: white;
  }

  button {
    background: transparent;
    border: none;
    padding: 0 8px;
    display: flex;
    height: 20px;
    display: flex;
    align-items: center;

    svg{
      path{
        fill: white;
      }
    }
  }
`;

interface Props {
  product: productType;
  bag?: boolean
}
const Product = (props: Props) => {
  const product = props.product;
  const history = useHistory();
  const [cart, setCart] = useRecoilState<any>(cartState);
  const hasCart = cart.find((item: productType) => item.slug === product.slug);
  const addProductHook = useAddProduct();
  const removeProductHook = useRemoveProduct();

  const setProductAnalitycs = () => {
    return {
      'name': product.name,
      'id': product.slug,
      'price': product.price,
      'category': product.category,
      'quantity': 1
    }
  }

  const openDetails = () => {
    history.push("/product/" + product.slug);
  };

  const addClick = () => {
    product.options ? openDetails() : addProduct(product);
  };

  const addProduct = (product: productType) => {
    addProductHook(product);
    logEvent(analytics, "add_to_cart", { 'products': [setProductAnalitycs()] })

  }

  const removeProduct = (product: productType) => {
    removeProductHook(product);
    logEvent(analytics, "remove_from_cart", { 'products': [setProductAnalitycs()] })
  }

  const AddControls = () => {
    return (
      <AddButton onClick={() => addClick()} aria-label="Agregar">
        <PlusIcon />
      </AddButton>
    );
  }

  const QuantityControls = () => {
    if (hasCart) {
      if (product.options) {
        return (props.bag ? (
          <AddButton onClick={() => removeProduct(product!)}>
            <RemoveIcon />
          </AddButton>
        ) : AddControls())
      } else {
        return (
          <CountButton>
            <motion.button aria-label="quitar uno" onClick={() => removeProduct(product!)}><LessIcon /></motion.button>
            <p>{hasCart && hasCart.qty}</p>
            <motion.button aria-label="agregar uno" onClick={() => addProduct(product!)}><PlusIcon /></motion.button>
          </CountButton>
        );
      }
    } else {
      return AddControls()
    }
  };

  return (
    <ProductContainer>
      {product.imageUrl ? (
        <div style={{position: "relative"}}>
          {product.discount ? <DiscountBadge>{product.discount}%</DiscountBadge> : ""}
          <ProductPicture onClick={() => openDetails()} src={product.imageUrl} alt={product.name} loading="lazy" title={product.name}  />
        </div>
      ) : (
        <SeparatorProduct />
      )}
      <ProductContent onClick={() => openDetails()}>
        <h3 >{product.name}</h3>
        <p>{product.description}</p>
      </ProductContent>
      <PriceActions>
        <h4>
          {product.priceDiscounted && <DiscountedPrice>$ {product.priceDiscounted}</DiscountedPrice>}
          <span>$ </span> {product.price}
        </h4>
        {QuantityControls()}
      </PriceActions>
    </ProductContainer>
  );
};

export default Product;
